import {
  useGetPricesQuery,
  useGetInstrumentsPricesQuery,
  useGetPortfoliosQuery,
  useGetLiquidityTiersQuery,
} from 'store/api/merklebaseAPI'
import useIconPreloader from 'hooks/useIconPreloader'

/**
 * Prefetches RTK Query data at layout level for use with selectors.
 * Ensures reference data is in cache so child components can use useSelector
 * with selectors instead of calling hooks - reducing re-renders.
 * Also preloads common icons for better performance.
 * Renders nothing.
 */
const RTKQueryPrefetcher = () => {
  useGetPricesQuery(undefined, {
    pollingInterval: 1000 * 60,
  })
  useGetInstrumentsPricesQuery(undefined, {
    pollingInterval: 1000 * 60,
  })
  useGetPortfoliosQuery({ ignoreAUM: true })
  useGetPortfoliosQuery({ ignoreAUM: false })
  useGetLiquidityTiersQuery()
  
  // Preload common icons when prices are available
  useIconPreloader()
  
  return null
}

export default RTKQueryPrefetcher
